











import { Zastosowanie } from "@megarax/client/src/resources/plm/Zastosowanie";
import PropertyField from "./PropertyField";
import { Form } from "element-ui";
import { createComponent, createElement, computed } from "@vue/composition-api";

interface Props {
  value: Zastosowanie;
}

export default createComponent<Props>({
  components: {
    PropertyField,
  },
  name: "ZastosowanieForm",
  props: {
    value: { required: true },
  },
  setup(props, ctx) {
    const attributes = computed(() =>
      props.value.category.attributes.sort((a, b) => a.index - b.index),
    );

    function onPropertyInput(key: string, val: any) {
      ctx.root.$set(props.value.properties, key, val);
    }

    return { attributes, onPropertyInput };
  },
});
